// config 全局配置相关api
import request from '@/utils/request'
// 获取配置
export function getConfig() {
  return request({
    url: '/admin/system_config/content',
    method: 'post'
  })
}
// 更新配置
export function UpdataConfig(data) {
  return request({
    url: '/admin/system_config/update',
    method: 'post',
    data: data
  })
}

// 获取新全局参数列表数据
export function getList(data) {
  return request({
    url: '/admin/systemConfig2/list',
    method: 'post',
    data: data
  })
}
export function categoryList(data) {
  return request({
    url: '/admin/systemConfig2/categoryList',
    method: 'post',
    data: data
  })
}
// 新全局参数新增
export function saveNewParams(data) {
  return request({
    url: '/admin/systemConfig2/save',
    method: 'post',
    data: data
  })
}

// 新全局参数编辑
export function updateNewParams(data) {
  return request({
    url: '/admin/systemConfig2/update',
    method: 'post',
    data: data
  })
}

// 新全局参数删除
export function deleteNewParams(data) {
  return request({
    url: '/admin/systemConfig2/delete',
    method: 'post',
    data: data
  })
}

// 新全局参数可选择的模块
export function systemConfigmemo() {
  return request({
    url: '/admin/systemConfig2/list/memo',
    method: 'post'
  })
}
